/* eslint eqeqeq: 0 */
import { SET_LOADING } from "../constants/spinner";

export default function spinner(state = false, action) {
  if (action.type == SET_LOADING) {
    return { loading: action.loading };
  }
  return state;
}
